import {
	Collections,
	type BoatsResponse,
	type BookingsRecord,
	type BookingsResponse,
	type CancellationPoliciesResponse,
	type ListingsResponse,
	type PriceBreakdownLine,
	type UsersResponse
} from '@/pocketbase/pocketbase-types';
import { pb } from '@/utils/ApiClient';

export type BookingGuestContact = {
	email: string;
	name?: string;
	lastName?: string;
	phone?: string;
	message?: string;
};

type BookingExpand = {
	listing: ListingsResponse<{ cancellationPolicy: CancellationPoliciesResponse }>;
	boat: BoatsResponse;
	owner: UsersResponse;
};

/** Payload held between listing page and confirmation (includes non-PB fields). */
export type BookingStorePayload = Omit<Partial<BookingsRecord>, 'expand'> & {
	user?: string;
	guestContact?: BookingGuestContact;
	boat?: string;
	numberOfDays?: number;
	totalPrice?: number;
	priceBreakdown?: PriceBreakdownLine[];
	expand?: BookingExpand;
};

let bookingStore: BookingStorePayload | undefined = $state(undefined);

export function getBookingStore() {
	return bookingStore;
}

export function setBookingStore(booking: BookingStorePayload) {
	bookingStore = booking;
}

export async function createBooking(booking: BookingsRecord): Promise<BookingsResponse | Error> {
	try {
		const response: BookingsResponse = await pb
			.collection(Collections.Bookings)
			.create(booking, { expand: 'listing.boat.owner, listing.boat.port' });
		return response;
	} catch (e) {
		console.error(e);
		return e as Error;
	}
}

export async function updateBooking(booking: BookingsResponse) {
	try {
		const response: BookingsResponse = await pb
			.collection(Collections.Bookings)
			.update(booking?.id);
		console.log(response);
		booking = response;
	} catch (e) {
		console.error(e);
	}
}
